import { Component, Input, ViewChild } from '@angular/core';
import { PmdModal } from '@app/shared/propeller';

@Component({
  selector: 'app-invoice-review-modals',
  templateUrl: './invoice-review-modals.component.html',
})
export class InvoiceReviewModalsComponent {
  @Input() context: any;
  @Input() isAdmin = false;

  @ViewChild('submitModal') submitModal: PmdModal;
  @ViewChild('panModal') panModal: PmdModal;
  @ViewChild('RejectInvoice') RejectInvoice: PmdModal;
  @ViewChild('draftReasonPopup') draftReasonPopup: PmdModal;
  @ViewChild('duplicateModal') duplicateModal: PmdModal;
  @ViewChild('deleteCreditEntriesModal') deleteCreditEntriesModal: PmdModal;
  @ViewChild('mergeConfirmation') mergeConfirmation: PmdModal;
  @ViewChild('unsavedChangesModal') unsavedChangesModal: PmdModal;
  @ViewChild('deleteAllProducts') deleteAllProducts: PmdModal;
  @ViewChild('adminAlertModal') adminAlertModal: PmdModal;
}
